export default "__VITE_ASSET__DfCmpwo6__"